import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's a hash in the URL, we need to scroll to that element with offset
    if (hash) {
      // Slight delay to ensure the DOM is fully loaded
      setTimeout(() => {
        const element = document.getElementById(hash.substring(1));
        if (element) {
          // h-20 = 80px in most Tailwind configs
          const navbarHeight = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - navbarHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }
      }, 100);
    } else {
      // If no hash, scroll to top, but leave space for the navbar
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [pathname, hash]);

  return null;
}
